import Image from '@creator/ui/components/Image/Image';
import { getDomainConfigValue, getLogoSrc } from '@src/model/config/helpers';
import type { FC } from 'react';
import { memo } from 'react';

export interface LogoProps {
    className?: string;
}

const Logo: FC<LogoProps> = props => {
    const { className } = props;
    const alt = `${getDomainConfigValue('domainDisplayName')} logo`;
    return <Image data-ssr="logo-image" alt={alt} className={className} src={getLogoSrc()} />;
};

export default memo(Logo);
